module.exports = __webpack_public_path__ + "static/media/mealpal.0834b468.gif";